import { assets, icons } from 'common';
import styled, { css } from 'styled-components';

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/wallet.css */
  .wallet_page_wrapper {
    width: 100%;
    padding: 0 30px;
    min-width: 0;
    margin: 30px 0 0 0;
  }
  #wallet_content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    position: relative;
    flex-direction: row;
  }
  .wallet_page_wrapper h1 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: -0.02em;
  }
  .wallet_page_balance {
    flex-flow: column;
    align-items: flex-start;
    justify-content: center;
    min-width: 470px;
    display: flex;
  }
  .wallet_page_balance .total_balance_wrapper {
    justify-content: flex-start;
    align-items: center;
    flex-flow: row;
    display: flex;
    border-top: 1px solid var(--toggle-background);
    padding: 10px 0 0 0;
  }
  .wallet_page_balance .available_balance_wrapper {
    justify-content: flex-start;
    align-items: center;
    flex-flow: row;
    display: flex;
    padding: 10px 0;
  }
  .wallet_page_balance .balance_value {
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: -0.02em;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .wallet_page_balance .balance_value.available_balance_value {
    font-size: 1rem;
  }
  .wallet_page_balance .balance_value .currency_type {
    font-size: 1rem;
    margin: 0 0 0 10px;
  }
  .wallet_page_balance .balance_value.available_balance_value .currency_type {
    font-size: 0.8rem;
  }
  .total_balance_wrapper strong {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 0.9rem;
    opacity: 0.7;
    min-width: 200px;
    display: flex;
    align-items: center;
    display: flex;
  }
  .available_balance_wrapper strong {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 0.8rem;
    opacity: 0.7;
    min-width: 200px;
    display: flex;
    align-items: center;
    display: flex;
  }
  .wallet_tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 30px 0 0 0;
  }
  .wallet_tab_1 {
    cursor: pointer;
    padding: 20px 30px;
    margin: 0;
    border-radius: 0 10px 10px 0;
    font-size: 0.9rem;
    border: 1px solid var(--tab-bar-border);
    width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    color: var(--tab-bar-color);
  }
  #deposit_tab_one:checked ~ .tabs #deposit_tab,
  #withdraw_tab_two:checked ~ .tabs #withdraw_tab {
    background: var(--tab-bar-active-background);
    font-weight: 800;
    color: var(--tab-bar-active-color);
    border: 1px solid var(--tab-bar-active-border);
  }
  .wallet_tabs_wrapper .tabs {
    width: 100%;
    display: flex;
    margin: 0 0 30px 0;
  }
  .wallet_panels_1 {
    width: 100%;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
  }
  .wallet_tabs_panel {
    display: none;
    width: 100%;
  }
  .panel_title {
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    flex-flow: column;
    text-align: center;
  }
  .panel_icons {
    display: flex;
    gap: 5px;
  }
  .minimum_deposit {
    display: flex;
    gap: 3px;
    font-weight: bold;
    font-size: 18px;
  }
  .panel_icons img {
    height: 35px;
    margin: 0 0 10px 0;
  }
  .panel_ui_type {
    margin: 10px 0 0 0;
    background: hsla(0, 0%, 0%, 1);
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 0.8rem;
  }
  .tabbed_section.polygon .panel_ui_type {
    background: hsl(262, 75%, 57%);
  }
  .tabbed_section.ethereum .panel_ui_type {
    background: hsl(214, 94%, 57%);
  }
  .panel_desc {
    font-size: 0.8rem;
    opacity: 0.7;
    padding: 5px 0 15px 0;
    width: 100%;
    border-bottom: 1px solid var(--toggle-background);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 140%;
  }
  .panel_desc img.cc {
    width: 55px;
    margin: 10px 0 0 0;
    display: block;
  }
  .radio {
    display: none;
  }
  #deposit_tab_one:checked ~ .wallet_panels_1 #deposit_panel {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
  }
  #withdraw_tab_two:checked ~ .wallet_panels_1 #withdraw_panel {
    display: grid;
    grid-template-columns: 1fr;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: row;
  }
  .tabs #deposit_tab {
    border-radius: 5px 0 0 5px;
  }
  .wallet_tabs_panel .tabbed_section {
    background: hsla(214, 18%, 25%, 0.3);
    border-radius: 10px;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 10px 0 0;
  }
  .wallet_tabs_panel .tabbed_section:nth-child(3) {
    margin: 0;
  }
  .wallet_tabs_panel .tabbed_section.deposit_history,
  .wallet_tabs_panel .tabbed_section.withdraw_history {
    width: 100%;
    margin: 10px 0 0 0;
  }
  .tabbed_section {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
  }
  .tabbed_section form {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: flex-start;
  }
  .tabbed_section form input[type='text'] {
    width: 100%;
    padding: 10px 16px;
    background: var(--input-background);
    color: #fff;
    border: 1px solid var(--input-border);
    border-radius: 10px;
    font-size: 1.3rem;
    font-weight: 300;
    line-height: 100%;
  }
  .tabbed_section form .label_row {
    display: flex;
    justify-content: space-between;
    flex-flow: row;
    width: 100%;
    margin: 0 0 5px 0;
  }
  .tabbed_section form input[type='text']:focus {
    outline: 0;
    border: 1px solid var(--input-border);
  }
  .tabbed_section form .withdraw_assistance {
    color: #fff;
    width: 100%;
    font-size: 0.8rem;
    opacity: 0.5;
    padding: 10px 0 5px 0;
    text-align: center;
    line-height: 130%;
  }
  .tabbed_section form button {
    width: 100%;
    padding: 16px;
    font-size: 1rem;
    margin: 5px 0 0 0;
    line-height: 100%;
  }
  .tabbed_section form button:hover {
    background: var(--primary-button-hover-background);
  }
  #my-dashboard-grid {
    margin: 20px 0 0 0;
  }
  .main_cards.full.user_dashboard {
    margin: 0;
  }
  .withdraw_sections_wrapper .mm_address_wrapper {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
  }
  .mm_address_top {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
  }
  .mm_address_top div {
    align-items: center;
  }
  #wallet_content .label_row {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    margin: 15px 0 5px 0;
    font-size: 0.75rem;
  }
  .mm_address_bottom {
    flex-direction: column;
    width: 100%;
  }
  .mm_address_bottom .wallet_id_full {
    padding: 16px 16px 12px 16px;
    background: #111722;
    border-radius: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    margin: 0;
    position: relative;
  }
  .mm_address_bottom .wallet_id_full:hover {
    cursor: pointer;
  }

  .wallet_panels_1 #deposit_panel .mm_address_bottom .information_message {
    width: 100%;
    font-size: 0.7rem;
    opacity: 0.6;
    padding: 5px 30px 0 0;
  }
  .mm_address_bottom .wallet_id_full span {
    font-size: 1rem;
    flex-direction: row;
    width: auto;
    margin: 0 30px 0 0;
    word-break: break-all;
    line-height: 120%;
  }
  .mm_address_bottom .wallet_id_full .copy_icon {
    background-color: #fff;
    -webkit-mask: url(${icons.copy_icon}) no-repeat;
    -webkit-mask-size: auto 16px;
    -webkit-mask-position: center center;
    width: 16px;
    height: 16px;
    margin: 0 0 0 10px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  .mm_address_wrapper .withdraw_amount {
    margin: 0 0 5px 0;
    display: flex;
    flex-flow: column;
  }
  .widthdraw_app_balance {
    font-size: 1.8rem;
    letter-spacing: -0.03em;
    font-weight: 300;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .widthdraw_app_balance label {
    font-size: 0.8rem;
    text-transform: uppercase;
    color: #888b92;
    letter-spacing: 0;
    padding: 10px 0 5px 0;
  }
  .wallet_page_balance_wrapper {
    justify-content: center;
    align-items: flex-start;
    margin: 15px 60px;
    flex-flow: column;
    width: 100%;
    display: flex;
  }

  @media (max-width: 1200px) {
    #deposit_tab_one:checked ~ .wallet_panels_1 #deposit_panel,
    #withdraw_tab_two:checked ~ .wallet_panels_1 #withdraw_panel {
      display: grid;
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr;
      justify-content: center;
    }
    .wallet_tabs_panel .tabbed_section {
      margin: 0 0 10px 0;
    }
    .wallet_page_balance_wrapper {
      margin: 0;
    }
  }
`;

const developerCSS = css`
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .tabbed_section form input[type='tel'] {
    width: 100%;
    padding: 10px 16px;
    background: var(--input-background);
    color: #fff;
    border: 1px solid var(--input-border);
    border-radius: 10px;
    font-size: 1.3rem;
    font-weight: 300;
    line-height: 100%;
  }
  .tabbed_section form input[type='tel']:focus {
    outline: 0;
    border: 1px solid var(--input-border);
  }
`;

export const WalletInfoCSS = styled.div`
  height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 70px;
  ${designerCSS}
  ${developerCSS}
`;
